var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSimplifiedIconPelatihan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 .863V5s-2.429 11.046-4 13.526C18.429 21 6.571 24 6.571 24H0v-4s.697-1.857 2.994-2H5v-4s.697-1.857 2.994-2H10V8s.697-1.857 2.994-2H15V2s.703-1.857 3-2h5.137c.474 0 .863.389.863.863z",
    fill: "#FCD222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5v11s-.857 5.691-1.594 6.189C20.497 23.474 16 24 16 24H6.571S18.43 21 20 18.526C21.571 16.046 24 5 24 5z",
    fill: "#FCD222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16s-.857 5.691-1.594 6.189C20.503 23.474 16 24 16 24h7.126c.48 0 .874-.389.874-.874V16zM0 18h2.994C.697 18.143 0 20 0 20v-2zm5-4s.697-1.857 2.994-2H5v2zm5-6s.697-1.857 2.994-2H10v2zm5.006-6S15.703.143 18 0h-2.994v2z",
    fill: "#FCD222"
  })));
}

export default SvgSimplifiedIconPelatihan;